import { render } from "./checkoutOrderConfirmation.vue?vue&type=template&id=376b5c32&ts=true"
import script from "./checkoutOrderConfirmation.vue?vue&type=script&lang=ts"
export * from "./checkoutOrderConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__